/**
 * Central registry of every app module that can be assigned to an employee in
 * Staff Management (permissions). Adding a NEW feature? Add ONE line here and it
 * automatically appears in the staff permissions list — nothing else to change.
 *
 * Hidden modules (see hiddenModules.js) are filtered out of the assignable list.
 */
import { isHiddenModule } from './hiddenModules';

export const APP_MODULES = [
  { id: 'dashboard',      fr: 'Tableau de bord',            ar: 'لوحة التحكم' },
  { id: 'clients',        fr: 'Clients',                    ar: 'الزبناء' },
  { id: 'cars',           fr: 'Véhicules',                  ar: 'السيارات' },
  { id: 'rentals',        fr: 'Contrats de location',       ar: 'عقود الكراء' },
  { id: 'reservations',   fr: 'Réservations',               ar: 'الحجوزات' },
  { id: 'calendar',       fr: 'Calendrier',                 ar: 'التقويم' },
  { id: 'finances',       fr: 'Finances',                   ar: 'المالية' },
  { id: 'invoices',       fr: 'Factures',                   ar: 'الفواتير' },
  { id: 'cheques',        fr: 'Chèques',                    ar: 'الشيكات' },
  { id: 'mokhalafat',     fr: 'Contraventions',             ar: 'المخالفات' },
  { id: 'staff',          fr: 'Personnel',                  ar: 'الموظفون' },
  { id: 'gps',            fr: 'GPS Tracking / Commandes',   ar: 'تتبع GPS / الأوامر' },
  { id: 'breakdowns',     fr: 'Pannes & Réparations',       ar: 'الأعطال والإصلاحات' },
  { id: 'history',        fr: 'Historique',                 ar: 'السجل' },
  { id: 'blacklistcheck', fr: 'Vérif. Liste Noire',         ar: 'التحقق من القائمة السوداء' },
  { id: 'referral',       fr: 'Parrainage',                 ar: 'الإحالة' },
  { id: 'analytics',      fr: 'Car Analytics',              ar: 'تحليلات السيارات' },
  { id: 'vidange',        fr: 'Entretien / Vidange',        ar: 'الصيانة / تغيير الزيت' },
  { id: 'settings',       fr: 'Paramètres',                 ar: 'الإعدادات' },
];

/** Modules an admin can grant to staff (excludes globally-hidden ones). */
export const getAssignableModules = () => APP_MODULES.filter((m) => !isHiddenModule(m.id));
